import React, { useState } from "react";
import "./Navbar.css";
import { Link } from "react-router-dom";
import { RiMenu3Line, RiCloseLine } from "react-icons/ri";

const Navbar = () => {
  const [toggleMenu, setToggleMenu] = useState(false);
  return (
    <div className="Navbar">
      <div className="Navbar-links">
        <Link className="Navbar-wordmark" to="/" aria-label="Shirley Massage Therapy home">
          <span className="Navbar-wordmark-full">Shirley Massage Therapy</span>
          <span className="Navbar-wordmark-short">SMT</span>
        </Link>
        <div className="Navbar-links_container">
          <p className="text-pop-up-top">
            <Link to="/about">ABOUT</Link>
          </p>
          <p className="text-pop-up-top">
            <Link to="/contact">CONTACT</Link>
          </p>
          <p className="text-pop-up-top">
            <Link to="/services">SERVICES</Link>
          </p>
          <p className="text-pop-up-top">
            <Link to="/incentives">INCENTIVES</Link>
          </p>
          {/* <p className="text-pop-up-top">
            <Link to="/gallery">Gallery</Link>
          </p> */}
        </div>
      </div>
      <div className="Navbar-social">
        <Link to="https://posts.gle/xwoLu1">
          <img src="/google_logo.png" alt="error"></img>
        </Link>
        <Link to="https://www.facebook.com/profile.php?id=61555562977264">
          <img src="/facebook_logo.png" alt="error"></img>
        </Link>
      </div>
      <div className="Navbar-menu">
        {toggleMenu ? (
          <RiCloseLine
            color="#2b5293"
            size={27}
            onClick={() => setToggleMenu(false)}
          />
        ) : (
          <RiMenu3Line
            color="#2b5293"
            size={27}
            onClick={() => setToggleMenu(true)}
          />
        )}
        {toggleMenu && (
          <div className="Navbar-menu_container scale-up-center">
            <p className="text-pop-up-top">
              <Link to="/" onClick={() => setToggleMenu(false)}>Home</Link>
            </p>
            <p className="text-pop-up-top">
              <Link to="/about" onClick={() => setToggleMenu(false)}>About</Link>
            </p>
            <p className="text-pop-up-top">
              <Link to="/contact" onClick={() => setToggleMenu(false)}>Contact</Link>
            </p>
            <p className="text-pop-up-top">
              <Link to="/services" onClick={() => setToggleMenu(false)}>Services</Link>
            </p>
            <p className="text-pop-up-top">
              <Link to="/incentives" onClick={() => setToggleMenu(false)}>Incentives</Link>
            </p>
            {/* <p className="text-pop-up-top">
              <Link to="/gallery">Gallery</Link>
            </p> */}
          </div>
        )}
      </div>
    </div>
  );
};

export default Navbar;
